import { useState } from 'react';
import { Tabs, Tab, Box, useMediaQuery } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import { useTheme } from '@mui/material/styles';
import MyPosts from './MyPosts';
import MyComments from './MyComments';

/* ▸ 글/댓글 두 패널을 탭으로만 전환 */
export default function PostsComments() {
    const [tab, setTab] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant={isMobile ? 'fullWidth' : 'standard'}
                centered={!isMobile}
                textColor="primary"
                indicatorColor="primary"
                size={isMobile ? 'small' : 'medium'}
            >
                <Tab
                    icon={isMobile ? null : <ArticleIcon fontSize="small" />}
                    label="글"
                />
                <Tab
                    icon={isMobile ? null : <ChatBubbleIcon fontSize="small" />}
                    label="댓글"
                />
            </Tabs>

            <Box sx={{ mt: 2 }}>
                {tab === 0 ? <MyPosts /> : <MyComments />}
            </Box>
        </Box>
    );
}